import { Component, EventEmitter, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { DynamicGridComponent } from '../../../dynamic-entity/components/dynamic-grid/dynamic-grid.component';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { UbiFilterService } from '../../../theme';

import { ApiService, MetadataService, ExpressionFilter, ExpressionRule, Operator, Condition } from '../../../ubi-core/ubi-core.module';
import { ToastrService } from 'ngx-toastr';
import { LocalizedDatePipe } from '../../../ubi-core/pipes/LocalizedDatePipe';

@Component({
  selector: 'app-movements',
  templateUrl: './movements.component.html',
  styleUrls: ['./movement.component.scss']
})
export class MovementsComponent extends DynamicGridComponent implements OnInit {

  @ViewChild('hdrTpl') hdrTpl: TemplateRef<any>;
  @ViewChild('statusTmpl') statusTmpl: TemplateRef<any>;

  protected columns = [];
  public filters = [];
  private selected = [];
  private processing = false;

  constructor(protected baseservice: ApiService, protected metadataservice: MetadataService,
    protected router: Router, protected route: ActivatedRoute, protected modalService: NgbModal,
    protected filterservice: UbiFilterService, protected toastr: ToastrService) {

    super(baseservice, metadataservice, router, route, modalService, filterservice);

  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected getMetadata() {

    this.columns = [
      {
        checkboxable: true, width: 30, sortable: false, canAutoResize: false,
        draggable: false, resizeable: false, frozenLeft: true
      },
      {
        prop: 'AnnouncementItemProductID', name: 'Anúncio', width: 49, canAutoResize: false, draggable: false,
        resizeable: false, headerTemplate: this.hdrTpl, cellTemplate: this.statusTmpl
      },
      { prop: 'Id', name: 'Id' },
      { prop: 'Type', name: 'Tipo' },
      { prop: 'VesselAndProcess', name: 'Navio e contramarca' },
      { prop: 'TruckingCompany', name: 'Emp. Camionagem' },
      { prop: 'TruckRegistration', name: 'Camião' },
      { prop: 'Product', name: 'Código Produto' },
      { prop: 'SoldTo', name: 'Consignatário' },
      { prop: 'ShipTo', name: 'Destinatário' },
      { prop: 'CreatedOn', name: 'Movimentado em', pipe: new LocalizedDatePipe('pt-PT', 'yyyy/MM/dd hh:mm:ss') },
      { prop: 'Inactive', name: 'Anulado' }
    ];

    this.columns = [...this.columns];

  }

  protected getInitialData() {
    this.baseservice.setEntity('backofficemovements');

    this.page.sorts = [{ prop: 'Id', dir: 'desc' }];

    // By default, filter by inactive = false
    if (this.filter === null || this.filter === undefined) {
      this.filter = new ExpressionFilter(Condition.AND);
    }

    if (this.filter.rules === null || this.filter.rules.filter(r => r.field === 'Inactive') === null) {
      //this.filter.addRule(new ExpressionRule('Inactive', Operator.Equal, false));
    }
    this.filterAdvanced = false;

    this.getPage({ offset: 0 }, this.filter);
  }

  protected newClick(event) {
    this.router.navigateByUrl('mobile/movements');
  }

  onRowSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  onRowClick(event) {
    if (event.type === 'click') {
      if (this.navigateUrl !== null && this.navigateUrl !== undefined) {
        this.router.navigateByUrl(this.navigateUrl + '/' + event.row.Id);
      }
    } else {
      event.event.stopPropagation();
    }
  }

  private setAnnouncementItems(event) {
    this.processing = true;
    this.baseservice.setEntity(this.entity + '/AssociateMovementsWithAnnouncementItems');
    const request = [];

    this.selected.forEach(movement => {
      request.push({
        'MovementId': movement.Id,
        'MovementType': movement.TypeID,
        'ProductCode': movement.Product,
        'TruckingCompanyId': movement.TruckingCompanyID,
        'TruckRegistration': movement.TruckRegistration,
        'TruckTrailer': movement.TruckTrailer,
        'VesselAndProcessId': movement.VesselAndProcessID
      });
    });

    this.baseservice.postRequest(request).subscribe(response => {
      this.processing = false;
      this.selected = [];
      this.baseservice.setEntity(this.entity);
      this.getInitialData();
    },
      error => {
        this.processing = false;
        console.log('Error set movements announcements items: ' + error);
        this.toastr.error('Erro ao tentar atribuir as linhas de anúncio aos movimentos selecionados.', '', { timeOut: 3000 });
      }
    );
    this.baseservice.setEntity('backofficemovements');
  }

  private displayCheck(row) {
    return row.AnnouncementItemProductID == null;
  }
}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/base/backoffice/movements/movements.component.ts